import { getHttpClient } from '../axiosInstance'

const base = '/vendor/jobs/v2'

export const load = async (id) => {
  const apiClient = getHttpClient()
  const url = `${base}/${id}`

  const response = await apiClient.get(url)
  return response.data
}

export const acceptTask = async (id, taskId) => {
  const apiClient = getHttpClient()

  const url = `${base}/${id}/tasks/${taskId}/accept`
  const response = await apiClient.put(url, {})
  return response.data
}

export const rejectTask = async (id, values) => {
  const apiClient = getHttpClient()
  const { taskId, ...form } = values

  const url = `${base}/${id}/tasks/${taskId}/reject`
  const response = await apiClient.put(url, form)
  return response.data
}

export const negotiateTask = async (id, values) => {
  const apiClient = getHttpClient()
  const { taskId, ...form } = values

  const url = `${base}/${id}/tasks/${taskId}/negotiate`
  const response = await apiClient.put(url, form)
  return response.data
}

export const completeTask = async (id, taskId) => {
  const apiClient = getHttpClient()

  const url = `${base}/${id}/tasks/${taskId}/complete`
  const response = await apiClient.put(url, {})
  return response.data
}
